import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme, Button, TextField, Checkbox, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, MenuItem, FormControl, Select } from '@mui/material';
import axios from 'axios'
import { TbLoader } from 'react-icons/tb';
import mainPath from '../../../utils/path';
import { useRef } from 'react';
import { MdOutlineRefresh } from "react-icons/md";

const useStyles = makeStyles((theme)=>({
  main: {
    
  },
  box:{
    margin:'0 auto',
    maxWidth:'1800px',
    padding:'0 20px',
  },
  popUpConfigBlockH1:{
    padding:'80px 0 20px 10px',
    fontWeight:'700',
    fontSize:'22px',
    display: 'flex'
  },
  datagridBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'scroll',
    overflowY: 'hidden',
    border: '1px solid #D3D3D3',
  },
  datagridTop: {
    display: 'flex',
    border: '1px solid #D3D3D3',
    borderTop: 'none',
  },
  datagridTopItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderLeft: '1px solid #D3D3D3',
    borderTop:'none',
    padding:'5px 0',
    [theme.breakpoints.down(1025)]: {
      display:'none',
    }
  },
  mobileDatagridTopItem:{
    display:'none',
    [theme.breakpoints.down(1025)]: {
      display:'flex',
      alignItems:'center',
      justifyContent:'center'
    }
  },
  contBox: {
    display: 'flex',
    alignItems: 'center',
  },
  checkBoxMain: {
    width: '10%',
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center'
  },
  contBoxItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  imageText:{
    width:'100%',
  },
  mimageText:{
    display:'none',
    [theme.breakpoints.down(1025)]: {
      display:'block',
      textAlign:'center',
    }
  },
  mobileContBoxItem:{
    display:'none',
    [theme.breakpoints.down(1025)]: {
      display:'block',
      textAlign:'center',
    }
  },
  textLeft: {
    display: 'flex', 
    flexDirection: 'row', 
    justifyContent: 'center', 
    alignItems: 'center',
    [theme.breakpoints.down(1025)]: {
      display:'none'
    }
  },
  innerDiv:{
    padding:'20px 10px',
    display:'flex',
    alignItems:'center',
    borderBottom:'1px solid #e2e2e2',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
    }
  },
  spanSpan:{
    fontSize:'18px',
    fontWeight:'500',
    width:'300px',
    marginRight:'10px',

    [theme.breakpoints.down(1025)]: {
      marginBottom:'10px',
      textAlign:'center'
    }
  },
  slideH1:{
    fontSize:'23px',
    
  },
  inputDiv:{
    [theme.breakpoints.down(1025)]: {
      padding:'10px 0 20px 80px '
    },
  },
  btnDivTopRight:{
    display:'flex',
    justifyContent:'end',
    paddingBottom:'20px',
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px',
    paddingBottom:'30px'
  },
  load:{
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
  },
  loadingIcon:{
    color:'#007235',
    fontSize:'50px',
    animation:'$loadSpin 5s infinite'
  },
  "@keyframes loadSpin":{
    from: { transform:'rotate(0deg)' },
    to: { transform:'rotate(1turn)' }
  },


}));


const PopUpConfig2 = () => {
  const checkBox = true
  const [checks, setChecks] = useState([])
  const [allChecked, setAllChecked] = useState(false)
  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);
  const fileInput = useRef();

  const onClearAttachment=()=>{
    fileInput.current.value = "";
  };

  const row = [
    {name: '팝업이미지', width:'100%'},
  ];

  const mobilerow = [
    {name: '팝업이미지', width: '100%'},
  ];

  const [data, setData] = useState([])

  const [img, setImg] = useState('')

  const theme = useTheme();
  const classes = useStyles(theme);

  const [open, setOpen] = useState(false);
  const [diaUrl, setDiaUrl] = useState('')

  const [loading, setLoading] = useState(false)

  const [delDial, setDelDial] = useState(false)

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      setData([])
      setImg('')
      setDiaUrl('')
      onClearAttachment()
    }
  }, [])

  const getItems = async() => {
    try {
      setLoading(true)
      const res = await axios.post('/api/adm/getPopup/' )

      if(res.data.success === false) {
        setErrSnack(true)
        setLoading(false)
        return ;
      }
      
      setData(res.data.result.reduce((result, item) => ([
        ...result, 
        [
        {id: item['sno'], data: item['img1'], type: 'imageText', img: item['img1']},
        ]
      ]), []))
      setLoading(false)

    } catch (e) {
      setErrSnack(true)
      setLoading(false)
      console.log(e)
    }
  }

  useEffect(() => {
    getItems()
  } , [])


  useEffect(() => {
    // 전체선택 관련 로직
    let allCheckList = []

    if(allChecked) {
      data.forEach(item => allCheckList.push(item[0].id));
      setChecks(allCheckList)
    } else {
      setChecks(allCheckList)
    }
    
  }, [allChecked])


  const addItem = async() => {
    if (img === '') return ;

    let formData = new FormData()
    formData.append("popup_img", img)

    try {
      const res = await axios.post(
        '/api/adm/addPopup/',
                            formData, 
                            {
                              headers: {
                                'Content-Type': 'multipart/form-data'
                              }
                            }
     )

      if (res.data.success === false) {
        setErrSnack(true)
      }
        
      setSuccSnack(true)
      getItems();
      setImg('')
      onClearAttachment()
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }

  }


  const delSelItems = async() => {
    let popList = []

    checks.forEach((arrItem) => {
      data.forEach((dataItem) => {
        if(dataItem[0].id === arrItem){
          popList.push({
            sno: dataItem[0].id,
          })
        } 
      })
    })

    try {
      const res = await axios.post('/api/adm/deletePopup/', {popup_list: popList} )

      if(res.data.success === false){
        setErrSnack(true)
        console.log('실패')
        return ;
      }

      setSuccSnack(true)
      setChecks([])
      setAllChecked(false)
      setDelDial(false)
      getItems()
      
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }



  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.popUpConfigBlock}>
      <div className={classes.box}>
        <h1 className={classes.popUpConfigBlockH1}>
          메인화면 팝업
          <div
              onClick={() => {
                setData([])
                setImg('')
                setDiaUrl('')
                setAllChecked(false)
                onClearAttachment()
                getItems()
              }}
            style={{cursor:'pointer'}}
          >
            <MdOutlineRefresh/>
          </div>
        </h1>
        <div className={classes.btnDivTopRight}>
          <Button 
            variant="outlined" 
            onClick={() => checks.length > 0 && setDelDial(true)}
          >
            선택삭제
          </Button>
        </div>
          <div className={classes.datagridBox}>
            <div className={classes.datagridTop}>
              {checkBox && (
                  <div className={classes.checkBoxMain}>
                    <Checkbox 
                      checked={allChecked}
                      onChange={e => setAllChecked(e.target.checked)}
                    />
                  </div>
              )}
              {row.map((item, index) => (
                        <div key={index} 
                          className={classes.datagridTopItem} 
                          style={{width: item.width}}
                        >
                          {item.name}
                        </div>
              ))}
              {mobilerow.map((mitem, index) => (
                  <div 
                    key={index}
                    className={classes.mobileDatagridTopItem}
                    style={{width: '100%'}}
                  >
                    {mitem.name}
                  </div>
                ))}
            </div>
            <div>
              
            </div>
    
            {loading ? (
              <div className={classes.load}>
                <TbLoader className={classes.loadingIcon}/>
              </div>
            ) :
            data.length > 0 && data.map((dataItem, dataIndex) => {
              return(
                      <div 
                        key={dataIndex} 
                        className={classes.contBox}
                        style={{
                          backgroundColor: dataIndex % 2 == 0 && '#F2F2F2'
                        }}
                      >
                          {checkBox && (
                            <div className={classes.checkBoxMain}>
                              <Checkbox
                                checked={checks.includes(dataItem[0].id)}
                                onChange={() => !checks.includes(dataItem[0].id) ?
                                                setChecks([...checks, dataItem[0].id]) : 
                                                setChecks([...checks.filter((item) => item !==  dataItem[0].id)])
                                          }
                              />
                            </div>
                          )}
    
                          {dataItem.map((item, index) => {
                            return(
                                <div 
                                key={index} 
                                className={classes.contBoxItem} 
                                style={{
                                    width: row[index].width,
                                }}
                                >
                                    {item.type === 'imageText' && (
                                        <div 
                                          className={classes.imageText} 
                                          onClick={() => {
                                            setDiaUrl(`${mainPath}/media/data/popup/${item.img}`)
                                            handleClickOpen()
                                          }}
                                        >
                                          <img
                                            style={{maxWidth: 300}}
                                            src={`${mainPath}/media/data/popup/${item.img}`} 
                                          />
                                        </div>
                                    )}    
                                                  
                                </div>
                          )})}
                      </div>
            )})}
    
          </div>
    
        <div className={classes.btnDiv}>
          <Button 
            variant="outlined" 
            onClick={() => checks.length > 0 && setDelDial(true)}
          >
            선택삭제
          </Button>
        </div>
      </div> 



      <div className={classes.slideDiv}>
        <div className={classes.box}>
          <div className={classes.innerDiv}>
            <h1 className={classes.slideH1}>새 팝업 등록</h1>
          </div>
    
          <div className={classes.innerDiv}>
            <span className={classes.spanSpan}>
              새 팝업 이미지 (1080 X 1350)<br/>
              (.gif, .jpg, .jpeg, .png 가능한 확장자)
            </span>
            {typeof(img) === 'string' ? img : img.name ? img.name : ''}
              <div className={classes.inputDiv}>
                <input 
                  type="file" 
                  accept=".gif, .jpg, .jpeg, .png"
                  onChange={(e) => {
                    setImg(e.target.files[0])
                  }}
                  ref={fileInput}
                />
              </div>
              <Button     
                variant="outlined"
                onClick={() => {
                  setImg('')
                  onClearAttachment()
                }}
              >
                이미지 삭제
              </Button>
          </div>
    
          <div className={classes.btnDiv}>
            <Button 
              variant="outlined"
              onClick={() => {addItem()}}
            >
              새 팝업 등록
            </Button>
          </div>
        </div>
      </div>

      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <img src={diaUrl} style={{width: 1000}} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}> 확인 </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={delDial}
        onClose={() => setDelDial(false)}
      >
        <DialogContent>
          <DialogContentText>
            정말 삭제 하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDelDial(false)}>아니오</Button>
          <Button onClick={() => delSelItems()}>네</Button>
        </DialogActions>
      </Dialog>

    </div>
  )
}

export default PopUpConfig2
